import axios from "axios";

export const USUARIOS_PROYECTOS_ENDPOINTS = {
  proyectos: "/proyectos/asignables",
  asignados: (idProyecto) => `/proyectos/${idProyecto}/usuarios-asignados`,
  disponibles: (idProyecto) => `/proyectos/${idProyecto}/usuarios-disponibles`,
  quitar: (idProyecto, usuarioId) =>
    `/proyectos/${idProyecto}/usuarios-asignados/${usuarioId}`,
};

export const getProyectosAsignables = async () => {
  const response = await axios.get(USUARIOS_PROYECTOS_ENDPOINTS.proyectos);
  return Array.isArray(response.data?.proyectos) ? response.data.proyectos : [];
};

export const getUsuariosAsignados = async (idProyecto) => {
  const response = await axios.get(
    USUARIOS_PROYECTOS_ENDPOINTS.asignados(idProyecto)
  );
  return Array.isArray(response.data?.usuarios) ? response.data.usuarios : [];
};

export const buscarUsuariosDisponibles = async (
  idProyecto,
  buscar = "",
  limit = 50
) => {
  const response = await axios.get(
    USUARIOS_PROYECTOS_ENDPOINTS.disponibles(idProyecto),
    { params: { buscar, limit } }
  );
  return Array.isArray(response.data?.usuarios) ? response.data.usuarios : [];
};

export const asignarUsuarioProyecto = async (idProyecto, usuarioId) => {
  const response = await axios.post(
    USUARIOS_PROYECTOS_ENDPOINTS.asignados(idProyecto),
    { usuarioId }
  );
  return response.data;
};

export const quitarUsuarioProyecto = async (idProyecto, usuarioId) => {
  const response = await axios.delete(
    USUARIOS_PROYECTOS_ENDPOINTS.quitar(idProyecto, usuarioId)
  );
  return response.data;
};
